import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST_V1 } from '../constants/constants';

export const getPatientNutrients = async (workflowToken) => {
  if (!workflowToken) {
    return null;
  }

  const apiURL = `${API_HOST_V1}/workflow_shares/${workflowToken}?phi=true&phi_otp=true`;

  const { token, userID } = useCurrentUser();

  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
      },
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
